/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
  TelegramProductsModeratorControllerFindRejectionReasons401,
} from '../types/TelegramProductsModeratorControllerFindRejectionReasons.ts';

function getTelegramProductsModeratorFindRejectionReasonsUrl() {
  const res = { method: 'GET', url: `/api/moderator/telegram/products/reasons` as const };
  return res;
}

/**
 * {@link /api/moderator/telegram/products/reasons}
 */
export async function telegramProductsModeratorFindRejectionReasons(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerFindRejectionReasons401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsModeratorFindRejectionReasonsUrl().url.toString(), ...requestConfig });
  return res.data;
}
